import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseUrlHelperService } from '../helper/baseUrlHelper.service';
import { NbcLoggerService } from '../logger/nbc-logger.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor(private http: HttpClient,
    private _apiroot: BaseUrlHelperService,
    private log: NbcLoggerService) {
  }


  //getEventNetworks(): Observable<any> {
  //  this.log.trace("calling getEventNetworks");
  //  return this.http.get(this._apiroot.baseUrl + "networks").pipe(
  //    catchError((err) => {
  //      return throwError(err);
  //    })
  //  );;
  //};

  getNetworks = (): Observable<any> => {
    this.log.trace('timesheetLookUpService: get Networks');
    return this.http
      .get(this._apiroot.baseUrl + 'talentPayroll/lookups/networks/get')
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  };

  getSports = (): Observable<any> => {
    this.log.trace("timesheetLookUpService: get Sports");
    //return $http.get(apiRoot + "talentPayroll/lookups/sports/get");
    return this.http
      .get(this._apiroot.baseUrl + 'talentPayroll/lookups/sports/get')
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  };

  getEmployeeTypes = (): Observable<any> => {
    this.log.trace("timesheetLookUpService: get Sports");
    //return $http.get(apiRoot + "talentPayroll/lookups/sports/get");
    return this.http
      .get(this._apiroot.baseUrl + 'talentPayroll/lookups/employeeTypes/get')
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  };


  getunionCodes = (): Observable<any> => {
    this.log.trace("timesheetLookUpService: get Sports");
    //return $http.get(apiRoot + "talentPayroll/lookups/sports/get");
    return this.http
      .get(this._apiroot.baseUrl + 'talentPayroll/lookups/unionCodes/get')
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  };

  getAirportCodes(term: any): Observable<any> {
    this.log.trace("calling getAirportCodes:" + JSON.stringify(term));
    return this.http.get<any>(
      this._apiroot.baseUrl + "global/airportCodes?term=" + encodeURIComponent(term))
      .pipe(
        map((data: any) => data && data.reference || [])
      );
  }


  getPayrollProviders(): Observable<any> {
    this.log.trace("calling getPayrollProviders");
    return this.http.get<any>(
      this._apiroot.baseUrl + "global/payrollProviders")
      .pipe(
        map((data: any) => data && data.reference || [])
      );
  };


}
